import IframeMessageBroker from '@flywire/internal-components/services/iframeMessageBroker/iframeMessageBroker';
import type { InjectPaymentMethodSelectorAppearanceSettings } from '@flywire/internal-components/services/iframeMessageBroker/model';
import { MESSAGES } from '@flywire/internal-components/services/iframeMessageBroker/model';

import {
  type InternalElementFactoryOptions,
  type PaymentMethodSelectorElementPublicOptions,
  SdkElement
} from '../../../model';
import { EventBus, type EventBusType } from '../../EventBus';
import { createIframe } from '../createIframe';
import { paymentMethodSelectorUrlBuilder } from './paymentMethodSelectorUrlBuilder';

export type PaymentMethodSelectorElementOptions = PaymentMethodSelectorElementPublicOptions &
  InternalElementFactoryOptions;

export const PaymentMethodSelectorElement = (
  options: PaymentMethodSelectorElementOptions
): SdkElement => {
  const { displayMode = 'container' } = options;
  const eventBus = EventBus();

  const mount = (id?: string) => {
    const url = paymentMethodSelectorUrlBuilder(options);
    const { iframe } = createIframe({
      containerId: id,
      src: url,
      displayMode,
      title: 'Flywire Payment Method Selector Element',
      containerErrorKey: 'paymentMethodSelectorElementContainerNotPresent'
    });

    sendAppearanceValuesToIframe(
      IframeMessageBroker.getInstance(),
      iframe,
      options.appearance,
      eventBus
    );

    IframeMessageBroker.getInstance().addListener(
      MESSAGES.PAYMENT_METHOD_SELECTOR_ELEMENT_SELECTED,
      data => {
        eventBus.onEvent('paymentMethodSelected', data);
      }
    );
  };

  return {
    mount,
    onEvent: (key, fn) => eventBus.addEvent(key, fn),
    registeredEvents: eventBus.registeredEvents
  };
};

const sendAppearanceValuesToIframe = (
  broker: ReturnType<(typeof IframeMessageBroker)['getInstance']>,
  iframe: HTMLIFrameElement,
  appearance: InternalElementFactoryOptions['appearance'],
  eventBus: EventBusType
) => {
  broker.addListener(MESSAGES.PAYMENT_METHOD_SELECTOR_ELEMENT_LOADED, () => {
    eventBus.onEvent('loaded', {});
    if (appearance) {
      broker.sendMessage<InjectPaymentMethodSelectorAppearanceSettings>(
        MESSAGES.INJECT_PAYMENT_METHOD_SELECTOR_APPEARANCE_SETTINGS,
        { appearance: { ...appearance } },
        iframe
      );
    }
  });
};
